module.exports = __webpack_public_path__ + "static/media/ungroup.decc0e01.svg";